import { useCallback } from 'react';

import { useLoyaltyServiceActivatePromotionMutation } from 'generated/graphql-gateway';

import { ActivatePromotionArgs, ActivatePromotionResult } from '../types';

export function useLoyaltyServiceActivatePromotion(): ActivatePromotionResult {
  const [activatePromotionMutation] = useLoyaltyServiceActivatePromotionMutation();

  const activatePromotion = useCallback(
    // loyaltyId is intentionally unused: the service resolves the authenticated
    // loyalty user server-side, so only the promotionId is sent.
    async ({ promotionId }: ActivatePromotionArgs) => {
      await activatePromotionMutation({ variables: { input: { promotionId } } });
    },
    [activatePromotionMutation]
  );

  return { activatePromotion };
}
